<template lang="pug">
  div
    div.p1.basic700--text {{ $t('select_courier_service') }}
    v-radio-group(v-if="showRadio" v-model="courierService" row dense)
      v-row(no-gutters)
        v-col
          v-radio(value="pickup" color="info500")
            template(v-slot:label)
              div.p2.primary--text {{ $t('pick_up') }}
        v-col
          v-radio(value="dropoff" color="info500")
            template(v-slot:label)
              div.p2.primary--text {{ $t('drop_off') }}
    template
      template(v-for="courier in couriers")
        div.px-2.py-4.my-2(:style="(selectedFulfilment && courier.service_id === selectedFulfilment.service_id) ? activeBorder : inactiveBorder" @click="selectedFulfilment = courier")
          v-row(no-gutters align="center")
            v-col.shrink
              div(style="width: 72px" align="center")
                v-img(:src="courier.shipping_logo || require('@/assets/image_placeholder.png')" contain max-width="72" max-height="32")
            v-col.pl-2
              div.p2.basic700--text {{ courier.shipping_name }}
              div.p2.basic700--text {{ courier.service_type }}
</template>

<script>
export default {
  name: 'BulkSelectCourier',
  props: ['parentRates', 'parentSelectedFulfilment'],
  data: () => ({
    activeBorder: {
      border: '2px solid var(--v-info500)',
      borderRadius: '4px',
      backgroundColor: 'var(--v-infoT08)'
    },
    inactiveBorder: {
      border: '1px solid var(--v-basic400)',
      borderRadius: '4px',
    },
    disabledBorder: {
      borderRadius: '4px',
      backgroundColor: 'var(--v-basic300)',
      opacity: 0.5
    },
    pickupCouriers: null,
    dropoffCouriers: null,
    courierService: null,
    showRadio: true,
  }),
  computed: {
    rates: {
      get () {
        return this.parentRates
      },
      set (newValue) {
        this.$emit('update:parentRates', newValue)
      }
    },
    selectedFulfilment: {
      get () {
        return this.parentSelectedFulfilment
      },
      set (newValue) {
        this.$emit('update:parentSelectedFulfilment', newValue)
      }
    },
    couriers () {
      if (this.courierService === 'pickup') {
        return this.pickupCouriers
      } else if (this.courierService === 'dropoff') {
        return this.dropoffCouriers
      } else {
        return []
      }
    }
  },
  watch: {
    rates: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val.length > 0) {
          this.pickupCouriers = [...val.filter(f => f.service_type === 'pickup')]
          this.dropoffCouriers = [...val.filter(f => f.service_type === 'dropoff')]
          if (this.pickupCouriers.length === 0) {
            this.courierService = 'dropoff'
            this.showRadio = false
          } else if (this.dropoffCouriers.length === 0) {
             this.courierService = 'pickup'
             this.showRadio = false
          }
        }
      }
    },
    selectedFulfilment: {
      deep: true,
      handler (val) {
        if (val) {
          this.courierService = val.service_type
        }
      }
    }
  },
  mounted () {
  },
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "select_courier_service": "Select courier service"
  },
  "id": {
    "select_courier_service": "Pilih layanan kurir"
  }
}
</i18n>